import { createSelector } from 'reselect';
import { IRootState } from 'store';
import { IUserState } from 'types';

export const userSelector = (state: IRootState): IUserState => state.users;

export const isTeacherSelector = createSelector(
  userSelector,
  (user) => user.userData?.type === 'teacher'
);
